export const CREATE_FILES_SINGLE = 'CREATE_FILES_SINGLE';
export const CREATE_FILES_MANY = 'CREATE_FILES_MANY';
export const UC_UPLOAD_FILE = 'UC_UPLOAD_FILE';
export const UC_COPY_FILE = 'UC_COPY_FILE';
